<template>
  <div class="yhc-service-level-info">
    <YhcEFSectionTitle>サービスレベル表印刷</YhcEFSectionTitle>
    <div class="yhc-service-level-export text-center">
      <div class="bold mb-3">配送元エリアを選択してください</div>
      <div class="d-flex justify-content-center gap-3 mb-3 pl-2 pr-2">
        <div style="max-width: 200px">
          <b-form-select
            size="lg"
            id="area-select"
            v-model="selectedAreaCode"
            :options="areaOptions"
          ></b-form-select>
        </div>
        <code>{{ selectedAreaCode }}</code>
        <div>
          <a
            href="#"
            class="export-button hover-fade"
            @click.prevent="exportServiceLevel"
          >
            エクスポート</a
          >
        </div>
      </div>
    </div>
    <YhcServiceLevelExportContents />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Icon from './ui/icons/index.vue'
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontPage/YhcEstimateFormFrontService'
import Badge from './ui/Badge.vue'
import Tooltip from './ui/Tooltip.vue'
import { yhcAreasByCode } from '../../../constants/area' // インポート文を追加
import YhcServiceLevelExportContents from './YhcServiceLevelExportContents.vue'

export default defineComponent({
  name: 'YhcServiceLevelExport',
  components: {
    Icon,
    Badge,
    Tooltip,
    YhcServiceLevelExportContents,
  },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  data() {
    return {
      selectedAreaCode: null, // 選択されたエリアコードを保持
    }
  },
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    hasFromToZip(): boolean {
      return !!(
        this.$yhcefs.$userInputData.zip_from && this.$yhcefs.$userInputData.zip_to
      )
    },
    areaOptions(): Array<{ value: string | null; text: string }> {
      const options = Object.keys(yhcAreasByCode)
        .sort((a, b) => {
          // 48, 49, 50を先頭に持ってくる
          if (a === '01') return -1
          if (b === '01') return 1
          if (a === '48') return -1
          if (b === '48') return 1
          if (a === '49') return -1
          if (b === '49') return 1
          if (a === '50') return -1
          if (b === '50') return 1
          return Number(a) - Number(b)
        })
        .map((code) => {
          return {
            value: code,
            text: yhcAreasByCode[code].short,
          }
        })
      // 先頭に「選択してください」オプションを追加
      return [{ value: null, text: '選択してください' }, ...options]
    },
  },
  methods: {
    async exportServiceLevel() {
      if (!this.selectedAreaCode) {
        this.$core.$toast.errorToast('配送元エリアを選択してください', {
          autoHideDelay: 5000,
        })
        return
      }
      // PDF出力の処理をここに追加（レイアウトを作成しつつ）
      const htmlElement = document.getElementById('service-level-print-area')
      const cloneElement = htmlElement?.cloneNode(true) as HTMLElement
      if (!cloneElement) {
        return
      }
      cloneElement.style.display = 'block' // 印刷エリアを表示
      await $core.$utils.htmlToPdf({
        htmlElement: cloneElement,
        filename: '【家財おまかせ便】サービスレベル表.pdf',
        paperWidth: '420mm',
        paperHeight: '297mm',
      })
    },
  },
})
</script>
